//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// chrome-mismatch imports
import { styles } from "./ChromePersonalCalendar.styles";
import { IContainer, IProps, IState } from "./ChromePersonalCalendar.d";
// other internals
import { A } from "@ui";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { toggleExpanded } from "@actions/settings.actions";
// util
import { sortDataSources } from "@util/data-source.util";
import { PostMessageManager } from "@util/post-message.util";
import { asCard } from "@components/card";
// material-ui
import { Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class ChromePersonalCalendarComponent extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  private onClick = () => {
    this.props.setSettingsDialogOpen(true);
    this.props.toggleExpanded("expandAccount");
  };

  private onClickClose = () => {
    PostMessageManager.closeSidebar(true);
  };

  public render() {
    const { user, org, windowUserEmail } = this.props;
    const sortedDataSources = sortDataSources(user.dataSources.edges, org.domains);
    const workCalendar =
      (sortedDataSources.work && sortedDataSources.work.length && sortedDataSources.work[0].name) ||
      "";
    const personalCalendar = sortedDataSources.other.find((ds) => ds.name === windowUserEmail);

    return (
      <div style={styles.description}>
        {personalCalendar &&
        personalCalendar.syncTargets &&
        personalCalendar.syncTargets.length > 0 ? ( // is syncing
          <div>
            Clockwise is automatically syncing&nbsp;
            {personalCalendar.name} to your work email {workCalendar}. View or edit your{" "}
            <A onClick={() => this.onClick()}>connected calendars</A> from Settings.
            <div>
              <Button onClick={this.onClickClose} style={{ marginTop: 10 }}>
                Hide Extension
              </Button>
            </div>
          </div>
        ) : (
          <div>
            You have connected this calendar to Clockwise, but syncing is currently turned off. View
            or edit your <A onClick={() => this.onClick()}>connected calendars</A> from Settings.
            <div>
              <Button onClick={this.onClickClose} style={{ marginTop: 10 }}>
                Hide Extension
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

//////////////////
// STYLE
//////////////////
export const ChromePersonalCalendarStyled = withStyles(styles)(ChromePersonalCalendarComponent);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    windowUserEmail: state.webExtension.windowUserEmail,
  };
}

const reduxContainer = connect(mapStateToProps, {
  setSettingsDialogOpen,
  toggleExpanded,
})(ChromePersonalCalendarStyled);

//////////////////
// RELAY
//////////////////

import { chromePersonalCalendarFragments } from "./ChromePersonalCalendar.gql";
export const ChromePersonalCalendar = createFragmentContainer<IContainer>(
  asCard<IContainer>(reduxContainer),
  chromePersonalCalendarFragments,
);
